<div class="casinolobbycontainer">
  <div class="box" *ngFor="let item of gameTypes" (click)="goGames(item)" [ngStyle]="{ 'background-image': 'url(' + item.img + ')' }">
    <span>{{ item.text }}</span>
  </div>
</div>
